import CartItem from '@/classes/CartObject';

class SkiPassCartItem extends CartItem {
  type = 'SKIPASS';

  guideCompleted = false;

  name = '';
  age = 0;
  category = '';
  subCategory = '';
  type = '';
  searchPackage = '';

  days = 0;
  startDate = null;

  cardNumber = null;
  refill = false;

  deliveryType = '';
  site = '';

  poolLid = 0;

  editableQuantity = false;

  constructor() {
    super();
    return true;
  }
}

export default SkiPassCartItem;



// WEBPACK FOOTER //
// ./src/classes/SkiPassCartItem.js